import { FC } from 'react';

import { createPortal } from 'react-dom';
import { PortalProps } from './Portal.interface';

export const Portal: FC<PortalProps> = (props) => {
  const { children, element = document.body } = props;

  return createPortal(children, element);
};
